var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_413_1236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2311 4.65448C20.4783 4.98869 19.6692 5.21377 18.82 5.31522C19.6871 4.79601 20.3529 3.97329 20.6658 2.99284C19.855 3.47368 18.9564 3.82323 17.9999 4.01165C17.2351 3.19575 16.143 2.68591 14.9357 2.68591C12.2254 2.68591 10.2338 5.21462 10.846 7.83966C7.35815 7.66489 4.26504 5.99386 2.19417 3.45407C1.09436 5.3408 1.6238 7.80897 3.49262 9.05883C2.80545 9.03666 2.15751 8.84825 1.59226 8.53365C1.54622 10.4783 2.94016 12.2977 4.95903 12.7027C4.3682 12.863 3.72111 12.9005 3.06293 12.7743C3.59663 14.4419 5.1466 15.6551 6.98472 15.6892C5.21992 17.0729 2.99643 17.691 0.769531 17.4285C2.62727 18.6195 4.83456 19.3143 7.20468 19.3143C14.9988 19.3143 19.4023 12.7317 19.1363 6.82767C19.9565 6.23514 20.6684 5.49596 21.2311 4.65448Z",
    fill: "#6B758B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_413_1236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.4615,
    height: 20.4615,
    fill: "white",
    transform: "translate(0.769531 0.769287)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2fb6842e703e1a9cbd1bfa57fa95121d.svg";
export { ForwardRef as ReactComponent };